var _style, _g, _path, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPart1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 902.6 332.2",
    style: {
      enableBackground: "new 0 0 902.6 332.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#21409A;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{display:none;fill:url(#SVGID_00000172428769620863244780000008163110637858382481_);}\r\n\t.st3{fill:url(#SVGID_00000140707040481074601130000012596358353093641902_);}\r\n\t.st4{display:none;fill:url(#SVGID_00000001649166260253763540000004763711009081138314_);}\r\n\t.st5{fill:#FFCA05;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.6,156.6V76.9h10.8v79.7H327.6z M333.1,87.1V76.9h37.3v10.3H333.1z M333.1,122.1v-10.2H366v10.2H333.1z  M333.1,156.6v-10.3h37.3v10.3H333.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.4,156.6V76.9h10.8v79.7H382.4z M387.8,87.1V76.9h37.3v10.3H387.8z M387.8,122.1v-10.2h32.9v10.2H387.8z  M387.8,156.6v-10.3h37.3v10.3H387.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.2,156.6V76.9h9.6l30.4,61.4l-1.5,1.4V76.9h10.5v79.7h-9.8l-30.3-59.9l1.5-1.4v61.4H437.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.2,157.4c-7.4,0-13.1-2.1-17.1-6.3c-4-4.2-6-10.2-6-17.9V76.9h10.8v56.8c0,4.2,1.1,7.5,3.2,9.8 c2.1,2.3,5.1,3.4,9,3.4c3.9,0,7-1.1,9.1-3.4c2.1-2.3,3.2-5.5,3.2-9.8V76.9h10.8v56.4c0,7.8-2,13.7-6,17.9 C563.3,155.3,557.6,157.4,550.2,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M586.8,156.6V76.9h10.8v79.7H586.8z M593.9,140l1.3-18.6l28.1-44.6h12.6L593.9,140z M626,156.6L605.8,114 l8-8.2l25,50.8H626z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M647.8,156.6V76.8h10.8v79.8H647.8z M652.7,122.9v-10.3h21c3,0,5.4-1,7.2-2.9c1.8-1.9,2.6-4.5,2.6-7.7v-4.1 c0-3.3-0.9-6-2.6-7.9c-1.8-2-4.2-2.9-7.2-2.9h-21V76.8H673c4.5,0,8.3,0.8,11.6,2.5c3.3,1.7,5.8,4,7.5,7.1s2.6,6.7,2.6,11v4.7 c0,4.3-0.9,8-2.7,11.1c-1.8,3.1-4.3,5.5-7.5,7.2c-3.2,1.7-7.1,2.5-11.5,2.5H652.7z M685.1,156.6l-14.7-36.2l10.5-2.5l16.6,38.7 H685.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M701.3,156.6l23.9-79.7h9.5l23.9,79.7h-11.6L730,92.8l-17.1,63.8H701.3z M714,139.2V129h32.8v10.2H714z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M779,76.9v79.7h-10.8V76.9H779z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M794.3,156.6V76.9h9.6l30.4,61.4l-1.5,1.4V76.9h10.5v79.7h-9.8l-30.3-59.9l1.5-1.4v61.4H794.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M858.7,156.6V76.9h10.8v79.7H858.7z M864.1,87.1V76.9h37.3v10.3H864.1z M864.1,122.1v-10.2h32.9v10.2H864.1z  M864.1,156.6v-10.3h37.3v10.3H864.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.1,265.8v-79.7h10.8v79.7H345.1z M350.6,196.3v-10.3h36.7v10.3H350.6z M350.6,232v-10.2H383V232H350.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.3,266.6c-4.9,0-9.1-1-12.7-3c-3.6-2-6.3-4.8-8.3-8.6c-1.9-3.7-2.9-8.1-2.9-13.1v-32c0-5.1,1-9.5,2.9-13.2 c1.9-3.7,4.7-6.5,8.3-8.5c3.6-2,7.8-3,12.7-3s9.1,1,12.7,3c3.6,2,6.3,4.8,8.3,8.5c1.9,3.7,2.9,8.1,2.9,13.2v32c0,5-1,9.4-2.9,13.1 c-1.9,3.7-4.7,6.6-8.3,8.6C429.4,265.6,425.2,266.6,420.3,266.6z M420.3,256c4,0,7.1-1.2,9.5-3.7c2.3-2.5,3.5-5.8,3.5-10v-32.7 c0-4.2-1.2-7.6-3.5-10.1c-2.3-2.5-5.5-3.7-9.5-3.7c-4,0-7.1,1.2-9.5,3.7c-2.3,2.5-3.5,5.8-3.5,10.1v32.7c0,4.2,1.2,7.6,3.5,10 C413.2,254.8,416.3,256,420.3,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.8,266.6c-7.4,0-13.1-2.1-17.1-6.3c-4-4.2-6-10.2-6-17.9v-56.4h10.8v56.8c0,4.2,1.1,7.5,3.2,9.8 c2.1,2.3,5.1,3.4,9,3.4c3.9,0,7-1.1,9.1-3.4c2.1-2.3,3.2-5.5,3.2-9.8v-56.8h10.8v56.4c0,7.8-2,13.7-6,17.9 C491.9,264.5,486.2,266.6,478.8,266.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.3,265.8v-79.7h9.6l30.4,61.4l-1.5,1.4v-62.8h10.5v79.7h-9.8l-30.3-59.9l1.5-1.4v61.4H515.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M579.7,265.8v-79.7h10.8v79.7H579.7z M586.8,265.8v-10.3h16.3c3.9,0,6.9-1.1,9-3.2c2.1-2.1,3.2-5.1,3.2-8.9 v-35.2c0-3.8-1.1-6.8-3.2-8.9c-2.1-2.1-5.1-3.2-9-3.2h-16.3v-10.3h16c7.5,0,13.3,2,17.4,5.9c4.1,3.9,6.1,9.5,6.1,16.7v34.6 c0,4.8-0.9,8.9-2.8,12.2c-1.8,3.4-4.5,5.9-8,7.7c-3.5,1.8-7.8,2.7-12.8,2.7H586.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M631.8,265.8l23.9-79.7h9.5l23.9,79.7h-11.6L660.5,202l-17.1,63.8H631.8z M644.4,248.4v-10.2h32.8v10.2H644.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M688.3,196.3v-10.3h47.5v10.3H688.3z M706.6,265.8v-73.2h10.8v73.2H706.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M755.9,186.1v79.7h-10.8v-79.7H755.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M794.3,266.6c-4.9,0-9.1-1-12.7-3c-3.6-2-6.3-4.8-8.3-8.6c-1.9-3.7-2.9-8.1-2.9-13.1v-32c0-5.1,1-9.5,2.9-13.2 c1.9-3.7,4.7-6.5,8.3-8.5c3.6-2,7.8-3,12.7-3s9.1,1,12.7,3c3.6,2,6.3,4.8,8.3,8.5c1.9,3.7,2.9,8.1,2.9,13.2v32c0,5-1,9.4-2.9,13.1 c-1.9,3.7-4.7,6.6-8.3,8.6C803.4,265.6,799.2,266.6,794.3,266.6z M794.3,256c4,0,7.1-1.2,9.5-3.7c2.3-2.5,3.5-5.8,3.5-10v-32.7 c0-4.2-1.2-7.6-3.5-10.1c-2.3-2.5-5.5-3.7-9.5-3.7c-4,0-7.1,1.2-9.5,3.7c-2.3,2.5-3.5,5.8-3.5,10.1v32.7c0,4.2,1.2,7.6,3.5,10 C787.1,254.8,790.3,256,794.3,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M831.6,265.8v-79.7h9.6l30.4,61.4l-1.5,1.4v-62.8h10.5v79.7h-9.8l-30.3-59.9l1.5-1.4v61.4H831.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 603.2574,
    y1: 203.9758,
    x2: 839.8486,
    y2: 203.9758,
    gradientTransform: "matrix(-1 0 0 1 841.8898 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#07A2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    style: {
      stopColor: "#1278BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    style: {
      stopColor: "#1A59AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8542,
    style: {
      stopColor: "#1F479E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21409A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.3,167.1v-8.2c0-45.3,53-82,118.3-82v172.3c0,45.3-53,82-118.3,82S2,294.4,2,249.1 C2,203.8,55,167.1,120.3,167.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067930425422214230720000010336728181478003111_",
    gradientUnits: "userSpaceOnUse",
    x1: 603.2574,
    y1: 185.5178,
    x2: 839.8486,
    y2: 185.5178,
    gradientTransform: "matrix(-1 0 0 1 841.8898 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00BAEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#07A2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4055,
    style: {
      stopColor: "#1278BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    style: {
      stopColor: "#1A59AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8542,
    style: {
      stopColor: "#1F479E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21409A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "url(#SVGID_00000067930425422214230720000010336728181478003111_)"
    },
    d: "M120.3,249.1v8.2 c-41.3,0-77.6,14.7-98.8,36.9C9.2,281.3,2,265.8,2,249.1c0-45.3,53-82,118.3-82v-8.2c0-45.3,53-82,118.3-82v90.2 C173.3,167.1,120.3,203.8,120.3,249.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000065796228564141380630000014850135534823286200_",
    cx: 787.4902,
    cy: -1.5844,
    r: 324.6998,
    gradientTransform: "matrix(-0.2 -0.9798 -0.6109 0.1247 210.8958 770.1997)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3766,
    style: {
      stopColor: "#FDE402"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#F6E207"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    style: {
      stopColor: "#EBDD11"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6872,
    style: {
      stopColor: "#DAD720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7542,
    style: {
      stopColor: "#C4CF32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    style: {
      stopColor: "#A8C449"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8672,
    style: {
      stopColor: "#88B864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9165,
    style: {
      stopColor: "#62AA84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9604,
    style: {
      stopColor: "#399BA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D8ACC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065796228564141380630000014850135534823286200_)"
    },
    d: "M2,11.2c65.3,0,118.3,36.7,118.3,82v65.6 v8.2v82c0,30.4,23.8,56.8,59.1,71c-17.4,7-37.6,11-59.1,11C55,331.1,2,294.4,2,249.1L2,11.2L2,11.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000119832495085754690640000009933882839637106611_",
    cx: 787.4902,
    cy: -1.5844,
    r: 324.6998,
    gradientTransform: "matrix(-0.2 -0.9798 -0.6109 0.1247 210.8958 770.1997)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3839,
    style: {
      stopColor: "#FDE300",
      stopOpacity: 0.1919
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5221,
    style: {
      stopColor: "#F6DD01",
      stopOpacity: 0.2611
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6208,
    style: {
      stopColor: "#EAD303",
      stopOpacity: 0.3104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    style: {
      stopColor: "#DAC305",
      stopOpacity: 0.3502
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7687,
    style: {
      stopColor: "#C4B009",
      stopOpacity: 0.3844
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    style: {
      stopColor: "#A8970D",
      stopOpacity: 0.4146
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8839,
    style: {
      stopColor: "#887A11",
      stopOpacity: 0.4419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9341,
    style: {
      stopColor: "#625817",
      stopOpacity: 0.467
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9789,
    style: {
      stopColor: "#39331D",
      stopOpacity: 0.4894
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "url(#SVGID_00000119832495085754690640000009933882839637106611_)"
    },
    d: "M2,11.2 c65.3,0,118.3,36.7,118.3,82v65.6v8.2v82c0,30.4,23.8,56.8,59.1,71c-17.4,7-37.6,11-59.1,11C55,331.1,2,294.4,2,249.1L2,11.2 L2,11.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "290.8,117.8 294.5,125.1 290.9,132.3 297,129.8 300.9,136.8 301.1,128 307.2,125.1 301,122.2  300.8,113.3 297,120.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "194.6,9.9 199.7,19.4 196,29.6 203.2,25.5 208.5,34.8 207.9,22.7 215,18.3 207.3,14.9 206.2,2.9  202.2,12.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "292.8,87.6 297.1,95.6 293.2,103.7 300,100.9 304.5,108.7 304.4,98.8 311.1,95.6 304.2,92.4  303.8,82.5 299.7,90.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "225.3,10 231.3,21 226.8,32.5 235.4,28.1 241.7,38.8 241,25 249.6,20.2 240.4,16 239.3,2.4  234.4,13.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "280.1,54.4 285.3,63.9 281,73.6 288.8,70.1 294.3,79.3 294,67.6 301.8,63.7 293.7,59.9 292.9,48.2  288.3,57.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "257.6,26.9 263.4,37.3 258.8,48 267.2,44 273.2,54.1 272.7,41.3 281.1,36.9 272.2,32.9 271.3,20  266.4,30.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "280.3,140.6 283.7,147.3 280.2,154 285.9,151.6 289.4,158.1 289.7,149.9 295.4,147.2 289.7,144.6  289.7,136.4 286,142.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "265.8,158.6 268.2,163.5 265.6,168.4 269.8,166.6 272.2,171.3 272.5,165.4 276.7,163.4 272.6,161.5  272.6,155.5 269.9,160.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "248,168.7 250.2,173.5 247.6,178.4 251.7,176.6 254.1,181.2 254.4,175.3 258.5,173.3 254.6,171.4  254.7,165.5 252,170.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "146.5,75.8 149.5,82.2 147.2,89.5 151.6,86.3 154.8,92.5 154.5,84.1 158.9,80.7 154.2,78.6  153.7,70.3 151.2,77.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "153.3,48.1 157,55.5 154.3,63.9 159.5,60.3 163.4,67.5 162.9,57.9 168.1,54 162.5,51.6 161.8,42  158.9,50.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "168.8,24.6 173.1,32.9 170,42.1 176,38.3 180.5,46.4 180,35.7 186,31.6 179.5,28.7 178.5,18.1  175.2,27  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.5,318c1.2,0.9,2.9,1.5,4.8,1.5c3.6,0,6.4-2.5,6.4-6.2c0-2.3-1.1-4.1-3.7-5.8c-3.2-2-4.6-4.2-4.6-6.7 c0-4.2,3.4-7.2,7.7-7.2c2,0,3.7,0.7,4.4,1.3l-0.7,1.4c-0.8-0.5-2.1-1.1-4-1.1c-3.5,0-5.7,2.6-5.7,5.3c0,2.5,1.2,4,3.9,5.7 c2.8,1.8,4.5,3.9,4.5,7.1c0,4-2.7,7.9-8.5,7.9c-1.9,0-4.2-0.7-5.1-1.6L345.5,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.4,293.9l-3.2,16.8c-0.2,1.2-0.3,2.3-0.3,3.4c0,3.8,2.1,5.4,5,5.4c3.8,0,6.4-2.6,7.5-8.8l3.2-16.9h1.7 l-3.3,17.1c-1.4,7.5-5.1,10.1-9.5,10.1c-3.4,0-6.5-2-6.5-6.8c0-1.1,0.1-2.3,0.3-3.5l3.2-16.8H368.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388.3,294.2c1.3-0.3,2.9-0.5,4.6-0.5c2.4,0,4.5,0.7,5.7,2.1c0.9,1.1,1.4,2.5,1.4,4.3c0,2.7-1.3,5.2-2.7,6.6 c-1.9,1.8-4.7,2.7-7.3,2.7c-1,0-1.8-0.1-2.7-0.2l-2.2,11.5h-1.7L388.3,294.2z M387.4,307.6c1,0.2,1.7,0.3,2.6,0.3 c5,0,8.1-3.5,8.1-7.7c0-3.3-2.1-5-5.6-5c-1.2,0-2.2,0.1-2.8,0.3L387.4,307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.7,294.2c1.3-0.3,2.9-0.5,4.6-0.5c2.4,0,4.5,0.7,5.7,2.1c0.9,1.1,1.4,2.5,1.4,4.3c0,2.7-1.3,5.2-2.7,6.6 c-1.9,1.8-4.7,2.7-7.3,2.7c-1,0-1.8-0.1-2.7-0.2l-2.2,11.5h-1.7L405.7,294.2z M404.9,307.6c1,0.2,1.7,0.3,2.6,0.3 c5,0,8.1-3.5,8.1-7.7c0-3.3-2.1-5-5.6-5c-1.2,0-2.2,0.1-2.8,0.3L404.9,307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.5,303.7c0,4.5-1.8,10.9-5.1,14.2c-2,2-4.6,3.2-7.5,3.2c-6.3,0-8.3-5.4-8.3-10c0-4.7,1.9-11.1,5.3-14.5 c2-1.9,4.7-3.1,7.3-3.1C437.8,293.5,439.5,298.9,439.5,303.7z M425.2,297.6c-3,3-4.7,9.1-4.7,13.1c0,4.1,1.5,8.9,6.8,8.9 c2.2,0,4.2-1,5.9-2.6c3-3,4.6-9.2,4.6-13c0-4.1-0.9-8.9-6.8-8.9C428.7,295,426.7,296,425.2,297.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M446.1,294.2c1.4-0.3,3.1-0.5,4.6-0.5c2.5,0,4.4,0.8,5.5,2c0.9,1.1,1.4,2.5,1.4,4c0,3.8-2.9,7.1-6.3,8v0.1 c2,0.6,2.9,2.7,3,5.9c0.2,4.2,0.4,6,0.6,7h-1.8c-0.2-0.6-0.3-3.5-0.5-6.6c-0.2-4-1.5-5.8-4.4-5.8h-3l-2.3,12.4h-1.7L446.1,294.2z  M445.4,306.8h2.8c4.5,0,7.4-3.2,7.4-7c0-3-2-4.6-5.3-4.6c-1.2,0-2.1,0.1-2.7,0.3L445.4,306.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.3,295.4h-7.3l0.3-1.5h16.3l-0.3,1.5h-7.3l-4.8,25.3h-1.7L467.3,295.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.4,293.9l-5.1,26.8h-1.7l5.1-26.8H481.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482.3,320.7l5.1-26.8h1.7l6.4,17.8c1,2.6,1.5,4.6,2,6.7l0.1,0c0.2-2.4,0.5-4.3,1.1-7.6l3.2-16.9h1.7 l-5.1,26.8h-1.6l-6.3-17.4c-1.1-2.8-1.6-4.7-2.1-7.1l-0.1,0c-0.3,2.5-0.7,4.8-1.2,7.8l-3.2,16.7H482.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520.7,319.7c-1.2,0.6-3.4,1.2-5.9,1.2c-3.4,0-6-1.1-7.7-3.3c-1.7-2.2-2.1-5-2.1-7.3c0-4.2,1.6-9.5,5.2-12.9 c2.6-2.4,6-3.7,9.5-3.7c2.6,0,4.2,0.6,4.9,1l-0.7,1.5c-1.2-0.6-2.6-1-4.7-1c-3,0-5.9,1.2-8.2,3.6c-2.7,2.7-4.2,7.4-4.2,11.3 c0,5.4,2.2,9.3,8.4,9.3c1.5,0,3-0.3,4-0.8l1.8-9.7h-5.6l0.3-1.5h7.3L520.7,319.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M539.3,294.2c1.3-0.3,2.8-0.5,4.5-0.5c2.4,0,4.2,0.6,5.4,1.9c0.9,1,1.3,2.3,1.3,3.8c0,3.3-2.6,6.1-5.9,7v0.1 c2.5,0.8,4.3,2.9,4.3,6c0,2.7-1.3,4.9-2.9,6.2c-1.9,1.6-4.5,2.1-7.3,2.1c-1.7,0-3.4-0.1-4.4-0.4L539.3,294.2z M536.3,319.1 c0.8,0.2,1.8,0.2,2.7,0.2c4.5,0,8.2-2.2,8.2-7c0-3.3-2.6-5.3-5.9-5.3h-2.6L536.3,319.1z M538.9,305.7h2.4c4.1,0,7.4-2.4,7.4-6.3 c0-2.8-1.9-4.2-5.2-4.2c-1.2,0-2.1,0.1-2.7,0.3L538.9,305.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M558.7,293.9l-3.2,16.8c-0.2,1.2-0.3,2.3-0.3,3.4c0,3.8,2.1,5.4,5,5.4c3.8,0,6.4-2.6,7.5-8.8l3.2-16.9h1.7 l-3.3,17.1c-1.4,7.5-5.1,10.1-9.5,10.1c-3.4,0-6.5-2-6.5-6.8c0-1.1,0.1-2.3,0.3-3.5l3.2-16.8H558.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M573.2,318c1.2,0.9,2.9,1.5,4.8,1.5c3.6,0,6.4-2.5,6.4-6.2c0-2.3-1.1-4.1-3.7-5.8c-3.2-2-4.7-4.2-4.7-6.7 c0-4.2,3.4-7.2,7.7-7.2c2,0,3.7,0.7,4.4,1.3l-0.7,1.4c-0.8-0.5-2.1-1.1-4-1.1c-3.5,0-5.7,2.6-5.7,5.3c0,2.5,1.2,4,3.9,5.7 c2.8,1.8,4.5,3.9,4.5,7.1c0,4-2.7,7.9-8.5,7.9c-1.9,0-4.2-0.7-5.1-1.6L573.2,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M596.1,293.9l-5.1,26.8h-1.7l5.1-26.8H596.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M597,320.7l5.1-26.8h1.7l6.4,17.8c1,2.6,1.5,4.6,2,6.7l0.1,0c0.2-2.4,0.5-4.3,1.1-7.6l3.2-16.9h1.7l-5.1,26.8 h-1.6l-6.3-17.4c-1.1-2.8-1.6-4.7-2.1-7.1l-0.1,0c-0.3,2.5-0.7,4.8-1.2,7.8l-3.2,16.7H597z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M632.3,307.3h-9l-2.2,11.8h10.2l-0.3,1.5h-11.9l5.1-26.8h11.3l-0.3,1.5h-9.6l-2,10.4h9L632.3,307.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M635.1,318c1.2,0.9,2.9,1.5,4.8,1.5c3.6,0,6.4-2.5,6.4-6.2c0-2.3-1.1-4.1-3.7-5.8c-3.2-2-4.7-4.2-4.7-6.7 c0-4.2,3.4-7.2,7.7-7.2c2,0,3.7,0.7,4.4,1.3l-0.7,1.4c-0.8-0.5-2.1-1.1-4-1.1c-3.5,0-5.7,2.6-5.7,5.3c0,2.5,1.2,4,3.9,5.7 c2.8,1.8,4.5,3.9,4.5,7.1c0,4-2.7,7.9-8.5,7.9c-1.9,0-4.2-0.7-5.1-1.6L635.1,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M651.1,318c1.2,0.9,2.9,1.5,4.8,1.5c3.6,0,6.4-2.5,6.4-6.2c0-2.3-1.1-4.1-3.7-5.8c-3.2-2-4.7-4.2-4.7-6.7 c0-4.2,3.4-7.2,7.7-7.2c2,0,3.7,0.7,4.4,1.3l-0.7,1.4c-0.8-0.5-2.1-1.1-4-1.1c-3.5,0-5.7,2.6-5.7,5.3c0,2.5,1.2,4,3.9,5.7 c2.8,1.8,4.5,3.9,4.5,7.1c0,4-2.7,7.9-8.5,7.9c-1.9,0-4.2-0.7-5.1-1.6L651.1,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M680.2,311.3l-4.6,9.4h-1.8l13.4-26.8h1.7l3.2,26.8h-1.7l-1.1-9.4H680.2z M689.1,309.8l-1-8.5 c-0.1-1.6-0.3-3.4-0.4-5.1h-0.1c-0.7,1.7-1.4,3.3-2.2,5.1l-4.3,8.6H689.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M695.7,320.7l5.1-26.8h1.7l6.4,17.8c1,2.6,1.5,4.6,2,6.7l0.1,0c0.2-2.4,0.5-4.3,1.1-7.6l3.2-16.9h1.7 l-5.1,26.8h-1.6l-6.3-17.4c-1.1-2.8-1.6-4.7-2.1-7.1l-0.1,0c-0.3,2.5-0.7,4.8-1.2,7.8l-3.2,16.7H695.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M722.8,294.2c1.7-0.3,3.5-0.5,5.3-0.5c4,0,7,1.3,8.6,3.5c1,1.4,1.8,3.6,1.8,6.5c0,5-1.9,10.5-5.3,13.6 c-2.8,2.5-6.3,3.5-10.3,3.5c-1.7,0-3.5-0.1-5.2-0.3L722.8,294.2z M719.8,319.1c1.2,0.2,2.5,0.2,3.3,0.2c4.1,0,7.1-1.2,9.4-3.6 c2.6-2.6,4.2-7.4,4.2-11.8c0-5-2.2-8.7-8.9-8.7c-1.2,0-2.6,0.1-3.6,0.3L719.8,319.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M764.2,319.9c-1.3,0.6-3.4,1.2-5.9,1.2c-6,0-9.1-4.3-9.1-10.5c0-4.4,1.5-9.7,5.1-13.2 c2.6-2.5,5.8-3.8,9.2-3.8c2.4,0,4.2,0.6,4.8,1.1l-0.7,1.4c-1-0.6-2.6-1-4.5-1c-2.8,0-5.6,1.2-7.7,3.3c-2.7,2.8-4.4,7.4-4.4,11.8 c0,5.1,1.8,9.4,7.7,9.4c1.8,0,3.8-0.4,5.1-1.1L764.2,319.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M774.6,293.9l-5.1,26.8h-1.7l5.1-26.8H774.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M780.5,320.7l-2.6-26.8h1.7l1.9,19.4c0.2,2.6,0.4,3.6,0.3,5h0.1c0.5-1.3,1.1-2.8,2.4-5.5l9.3-18.9h1.8 l-13.3,26.8H780.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M800.9,293.9l-5.1,26.8h-1.7l5.1-26.8H800.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M806.9,293.9h1.7l-4.8,25.3H814l-0.3,1.5h-11.8L806.9,293.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M823.8,293.9l-5.1,26.8H817l5.1-26.8H823.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M829,311.3l-4.6,9.4h-1.8l13.4-26.8h1.7l3.2,26.8h-1.7l-1.1-9.4H829z M838,309.8l-1-8.5 c-0.1-1.6-0.3-3.4-0.4-5.1h-0.1c-0.7,1.7-1.4,3.3-2.2,5.1l-4.3,8.6H838z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M844.6,320.7l5.1-26.8h1.7l6.4,17.8c1,2.6,1.5,4.6,2,6.7l0.1,0c0.2-2.4,0.5-4.3,1.1-7.6l3.2-16.9h1.7 l-5.1,26.8h-1.6l-6.3-17.4c-1.1-2.8-1.6-4.7-2.1-7.1l-0.1,0c-0.3,2.5-0.7,4.8-1.2,7.8l-3.2,16.7H844.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M866.6,318c1.2,0.9,2.9,1.5,4.8,1.5c3.6,0,6.4-2.5,6.4-6.2c0-2.3-1.1-4.1-3.7-5.8c-3.2-2-4.7-4.2-4.7-6.7 c0-4.2,3.4-7.2,7.7-7.2c2,0,3.7,0.7,4.4,1.3l-0.7,1.4c-0.8-0.5-2.1-1.1-4-1.1c-3.5,0-5.7,2.6-5.7,5.3c0,2.5,1.2,4,3.9,5.7 c2.8,1.8,4.5,3.9,4.5,7.1c0,4-2.7,7.9-8.5,7.9c-1.9,0-4.2-0.7-5.1-1.6L866.6,318z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPart1);
export default __webpack_public_path__ + "static/media/part1.b3733c5cf52535cadf16d9fef6c18dd3.svg";
export { ForwardRef as ReactComponent };